import {useQuery} from '@tanstack/react-query';
import {Row, Col, Input, Typography, List, Space} from 'antd';
import React, {useCallback, useState} from 'react';
import {TEVService} from '../tevapi/io';
import {debounce} from 'lodash';
import {Link, useSearchParams} from 'react-router-dom';


const SingleResult = (props) => {
  const resolvedName = (
    props.name ? props.name : `${props.tic_id}: ${props.slug}`
  );

  const delivery = props.delivery ? (props.delivery + " ") : "";

  const annotation = props.full_toi_id ? ` [${props.full_toi_id}]` : '';

  const text = `${delivery}${resolvedName}${annotation}`;

  return <Link to={props.url}>{text}</Link>;
};


const SearchResults = ({name, results}) => {

  return (
    <Col>
      <Typography.Title level={4}>{name}</Typography.Title>
      <List
        bordered
        dataSource={results}
        renderItem={
          (item) => (
            <List.Item>
              <SingleResult {...item} />
            </List.Item>
          )
        }
      />
    </Col>
  );
}


export default () => {
  const [searchParams, _] = useSearchParams();

  const [queryStr, setQueryStr] = useState(searchParams.get("q") || "");

  const debouncedSearch = useCallback(
    debounce(
      (value: string) => {
        setQueryStr(value)
      }, 500
    ),
    []
  );

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    debouncedSearch(e.target.value);
  };

  const {data, error, isLoading} = useQuery({
    queryKey: ["search", queryStr],
    queryFn: async () => {
      const response = await TEVService.get("/search", {params: {search: queryStr}});
      return response.data;
    },
    refetchOnWindowFocus: false
  });

  return (
    <>
      <Row>
        <Col>
          <Space direction='horizontal'>
            <Input
              placeholder="Search TEV"
              allowClear
              onChange={handleInputChange}
            />
          </Space>
        </Col>
      </Row>
      {isLoading && <Row><Col><Typography.Text>Loading...</Typography.Text></Col></Row>}
      {error && <Row><Col><Typography.Text>Error: {error.message}</Typography.Text></Col></Row>}
      {data && <Row gutter={16}>{data.map(props => <SearchResults {...props} />)}</Row>}
    </>
  );
};
